import React from "react";
import { Integration } from "../mockData";
import {
  CheckCircle2,
  AlertTriangle,
  Plus,
  Webhook,
  Database,
  Boxes,
  Server,
  Activity,
  Heart,
  Share2,
  KeyRound,
} from "lucide-react";

const CATEGORY_ICON: Record<string, React.ComponentType<{ className?: string }>> = {
  AMS:       Boxes,
  CMS:       Server,
  Storage:   Database,
  Webhook:   Webhook,
  Wearables: Activity,
  Health:    Heart,
  Social:    Share2,
  SSO:       KeyRound,
};

export function IntegrationGrid({ items }: { items: Integration[] }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {items.map((i) => {
        const Icon = CATEGORY_ICON[i.category] ?? Boxes;
        return (
          <div key={i.id} className="rounded-md border border-slate-200 p-4 bg-white">
            <div className="flex items-start gap-3">
              <div className="h-10 w-10 rounded-md bg-el-50 ring-1 ring-el-100 text-el-700 flex items-center justify-center">
                <Icon className="h-5 w-5" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <div className="text-sm font-semibold text-slate-900 truncate">{i.name}</div>
                  {i.status === "connected" ? (
                    <span className="badge bg-el-50 text-el-700 ring-1 ring-el-200">
                      <CheckCircle2 className="h-3 w-3" /> Connected
                    </span>
                  ) : i.status === "error" ? (
                    <span className="badge bg-rose-50 text-rose-700 ring-1 ring-rose-200">
                      <AlertTriangle className="h-3 w-3" /> Error
                    </span>
                  ) : (
                    <span className="badge bg-slate-100 text-slate-600 ring-1 ring-slate-200">
                      Available
                    </span>
                  )}
                </div>
                <div className="text-[0.7rem] uppercase tracking-[0.06em] text-slate-500 font-semibold mt-0.5">
                  {i.category}
                </div>
              </div>
            </div>
            <p className="mt-3 text-xs text-slate-600">{i.description}</p>
            <div className="mt-4 border-t border-slate-100 pt-3 flex items-center gap-2">
              <button className="btn-secondary !h-8 !text-xs">
                {i.status === "connected" ? "Manage" : "Connect"}
              </button>
              <button className="btn-ghost !h-8 !text-xs">Docs</button>
            </div>
          </div>
        );
      })}
      <div className="rounded-md border border-dashed border-slate-200 bg-white p-4 flex items-center justify-center">
        <button className="text-sm text-slate-500 hover:text-slate-700 inline-flex items-center gap-2">
          <Plus className="h-4 w-4" /> Suggest an integration
        </button>
      </div>
    </div>
  );
}

export function ApiCodeBlock({ orgName }: { orgName: string }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <pre className="text-xs leading-relaxed bg-slate-900 text-slate-100 rounded-md p-4 overflow-x-auto">
{`curl -X POST https://api.eleetz.app/v1/sessions \\
  -H "Authorization: Bearer \${ORG_KEY}" \\
  -F "video=@swing.mp4" \\
  -F "athleteId=a_1"`}
      </pre>
      <pre className="text-xs leading-relaxed bg-slate-900 text-slate-100 rounded-md p-4 overflow-x-auto">
{`{
  "id": "s_8821",
  "status": "queued",
  "athleteId": "a_1",
  "sport": "auto",
  "report": "auto",
  "org": "${orgName}"
}`}
      </pre>
    </div>
  );
}
